// This cache exists only for the current browser session. It makes navigating
// between customer-portal pages instant without retaining customer data on disk.
const bootstrapCache = new Map<string, unknown>();

// Page availability is customer-specific for administrators. Keep a distinct
// bootstrap entry per selected customer so a route change cannot reuse the
// previous customer's permissions.
export function getPortalBootstrapCacheKey(portalKey: string, customerId?: string) {
  return `${portalKey}:${customerId || "default"}`;
}

export function getCachedPortalBootstrap<T>(portalKey: string): T | null {
  return (bootstrapCache.get(portalKey) as T | undefined) || null;
}

export function setCachedPortalBootstrap<T>(portalKey: string, bootstrap: T) {
  bootstrapCache.set(portalKey, bootstrap);
}
